import React from "react";
import { useNavigate } from "react-router-dom";

const ShoulderBackPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .sb-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #fef9c3 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .sb-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .sb-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(234, 179, 8, 0.24), rgba(59, 130, 246, 0.08));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .sb-hero {
            grid-template-columns: 1fr;
          }
        }

        .sb-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(234, 179, 8, 0.24);
          color: #854d0e;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .sb-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #eab308;
        }

        .sb-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .sb-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .sb-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .sb-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .sb-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .sb-btnPrimary,
        .sb-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .sb-btnPrimary {
          background: #eab308;
          color: #0f172a;
          box-shadow: 0 10px 24px rgba(234, 179, 8, 0.4);
        }

        .sb-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(234, 179, 8, 0.55);
        }

        .sb-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .sb-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .sb-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .sb-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .sb-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .sb-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .sb-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .sb-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .sb-flexCol {
          flex: 1 1 260px;
        }

        .sb-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .sb-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .sb-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .sb-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #eab308;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .sb-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .sb-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .sb-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .sb-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE */
        .sb-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }

        .sb-step {
          padding: 10px 12px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .sb-stepLabel {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .sb-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* BANNER */
        .sb-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .sb-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .sb-banner img {
            height: 270px;
          }
        }

        .sb-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.78), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .sb-bannerText {
          color: #fefce8;
          font-size: 15px;
          max-width: 420px;
        }

        .sb-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .sb-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .sb-bannerButtons .primary {
          background: #eab308;
          color: #0f172a;
        }

        .sb-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .sb-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .sb-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .sb-bottomText strong {
          color: #fef9c3;
        }

        .sb-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .sb-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .sb-bottomActions .primary {
          background: #eab308;
          color: #0f172a;
        }

        .sb-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .sb-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="sb-page">
        <div className="sb-inner">
          {/* HERO */}
          <section className="sb-hero">
            <div>
              <div className="sb-tag">
                <span className="sb-tagDot" />
                Shoulder Region · Back
              </div>
              <h1 className="sb-title">
                Ease back-of-shoulder tightness so lifting, reaching, and sleeping feel better.
              </h1>
              <p className="sb-subtitle">
                The back of your shoulder — including the posterior deltoid and rotator cuff — helps
                you reach, pull, and control the arm. When these muscles are irritated, you might feel
                sharp or achy pain with reaching behind you or lying on that side.
              </p>

              <div className="sb-chips">
                <span className="sb-chip">Back-of-shoulder ache</span>
                <span className="sb-chip">Rotator cuff soreness</span>
                <span className="sb-chip">Pain with reaching behind</span>
                <span className="sb-chip">Side-sleeping discomfort</span>
              </div>

              <div className="sb-ctaRow">
                <button
                  className="sb-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book a shoulder visit →
                </button>
                <button
                  className="sb-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="sb-heroImgWrap">
              <img
                src="/content/shoulder-back/shoulder_back_hero.png"
                alt="Therapist assessing back of the shoulder"
                className="sb-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="sb-stripe">
            <div className="sb-sectionTitle">What can go wrong in the back of the shoulder?</div>
            <p className="sb-sectionSubtitle">
              The posterior deltoid and rotator cuff muscles work together to keep the ball of
              the shoulder centered in the socket while you move. If they&apos;re overloaded or
              under-supported, they let you know.
            </p>

            <div className="sb-flexRow">
              <div className="sb-flexCol">
                <ul className="sb-list">
                  <li>
                    <span className="sb-bullet" />
                    <span>
                      <strong>Posterior deltoid strain:</strong> aching on the back of the shoulder with
                      reaching behind or lifting away from the body.
                    </span>
                  </li>
                  <li>
                    <span className="sb-bullet" />
                    <span>
                      <strong>Rotator cuff irritation:</strong> discomfort with sleeping on that side,
                      reaching overhead, or rotating the arm.
                    </span>
                  </li>
                  <li>
                    <span className="sb-bullet" />
                    <span>
                      <strong>Scapular control issues:</strong> feeling “pinchy” or unstable during
                      pulling or overhead activity.
                    </span>
                  </li>
                  <li>
                    <span className="sb-bullet" />
                    <span>
                      <strong>Posture-related fatigue:</strong> back-of-shoulder tightness after long
                      periods sitting or working at a desk.
                    </span>
                  </li>
                </ul>

                <div className="sb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="sb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if your symptoms match →
                  </button>
                  <button
                    className="sb-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="sb-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/shoulder-back/shoulder_back_deltoid.png"
                  alt="Manual therapy on back of deltoid"
                  className="sb-img"
                />
              </div>
            </div>

            <div className="sb-cardGrid">
              <div className="sb-card">
                <div className="sb-cardTitle">Deltoid (Posterior)</div>
                <div className="sb-cardText">
                  The back portion of the main shoulder muscle, important for reaching behind and pulling.
                </div>
              </div>
              <div className="sb-card">
                <div className="sb-cardTitle">Rotator Cuff</div>
                <div className="sb-cardText">
                  A group of muscles that stabilize the shoulder joint and control fine movements.
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="sb-stripe">
            <div className="sb-flexRow">
              <div className="sb-flexCol">
                <img
                  src="/content/shoulder-back/shoulder_back_rotator_cuff.png"
                  alt="Therapist checking rotator cuff from back"
                  className="sb-img"
                />
              </div>

              <div className="sb-flexCol">
                <div className="sb-sectionTitle">How physical therapy supports the back of the shoulder</div>
                <p className="sb-sectionSubtitle">
                  We check how your shoulder blade, rotator cuff, spine, and rib cage all contribute to
                  shoulder motion and comfort.
                </p>

                <ul className="sb-list">
                  <li>
                    <span className="sb-bullet" />
                    <span>
                      <strong>Soft-tissue treatment:</strong> targeted work to the posterior deltoid and
                      rotator cuff to reduce guarding and sensitivity.
                    </span>
                  </li>
                  <li>
                    <span className="sb-bullet" />
                    <span>
                      <strong>Scapular mechanics:</strong> helping the shoulder blade move better on the ribs
                      when you reach or pull.
                    </span>
                  </li>
                  <li>
                    <span className="sb-bullet" />
                    <span>
                      <strong>Rotator cuff strengthening:</strong> specific exercises to help stabilize
                      the shoulder without over-fatiguing.
                    </span>
                  </li>
                  <li>
                    <span className="sb-bullet" />
                    <span>
                      <strong>Activity & sleep positions:</strong> practical tweaks for side-sleeping and
                      daily tasks so the area can calm down.
                    </span>
                  </li>
                </ul>

                <div className="sb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="sb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start with one shoulder session →
                  </button>
                  <button
                    className="sb-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SCAPULAR CONTROL */}
          <section className="sb-stripe">
            <div className="sb-sectionTitle">Shoulder blade control matters</div>
            <p className="sb-sectionSubtitle">
              The shoulder blade is the base for the ball-and-socket joint. If it doesn&apos;t glide well,
              the back of the shoulder can feel like it&apos;s doing too much work.
            </p>

            <div className="sb-flexRow">
              <div className="sb-flexCol">
                <div className="sb-timeline">
                  <div className="sb-step">
                    <div className="sb-stepLabel">1. Scapular position</div>
                    <div className="sb-stepText">
                      We check resting shoulder blade position and how it moves when you raise or lower your arm.
                    </div>
                  </div>
                  <div className="sb-step">
                    <div className="sb-stepLabel">2. Control with load</div>
                    <div className="sb-stepText">
                      We assess shoulder blade motion with light resistance or real-life tasks like reaching or pulling.
                    </div>
                  </div>
                  <div className="sb-step">
                    <div className="sb-stepLabel">3. Coordinated training</div>
                    <div className="sb-stepText">
                      You practice exercises that pair scapular control with rotator cuff and deltoid work.
                    </div>
                  </div>
                  <div className="sb-step">
                    <div className="sb-stepLabel">4. Progress to your goals</div>
                    <div className="sb-stepText">
                      We build toward your specific activities—lifting, sports, or daily overhead tasks.
                    </div>
                  </div>
                </div>

                <div className="sb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="sb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a shoulder & scapular eval →
                  </button>
                </div>
              </div>

              <div className="sb-flexCol">
                <img
                  src="/content/shoulder-back/shoulder_back_scapular_control.png"
                  alt="Therapist guiding scapular control from behind"
                  className="sb-img"
                />
              </div>
            </div>
          </section>

          {/* VISIT FLOW / EXERCISES */}
          <section className="sb-stripe">
            <div className="sb-sectionTitle">What a shoulder-back session may look like</div>

            <div className="sb-flexRow">
              <div className="sb-flexCol">
                <img
                  src="/content/shoulder-back/shoulder_back_exercises.png"
                  alt="Patient doing back-of-shoulder strengthening with guidance"
                  className="sb-img"
                />
              </div>

              <div className="sb-flexCol">
                <div className="sb-timeline">
                  <div className="sb-step">
                    <div className="sb-stepLabel">1. Your story</div>
                    <div className="sb-stepText">
                      We talk through what motions bother your shoulder most and what you want to return to.
                    </div>
                  </div>
                  <div className="sb-step">
                    <div className="sb-stepLabel">2. Motion & strength check</div>
                    <div className="sb-stepText">
                      We look at shoulder range, strength, and how your shoulder blade and spine move together.
                    </div>
                  </div>
                  <div className="sb-step">
                    <div className="sb-stepLabel">3. Hands-on care</div>
                    <div className="sb-stepText">
                      You try specific manual techniques and guided movements to ease irritation.
                    </div>
                  </div>
                  <div className="sb-step">
                    <div className="sb-stepLabel">4. Short home plan</div>
                    <div className="sb-stepText">
                      You leave with a small set of exercises and tips you can realistically fit into your day.
                    </div>
                  </div>
                </div>

                <div className="sb-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="sb-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book a shoulder evaluation →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="sb-stripe">
            <div className="sb-banner">
              <img
                src="/content/shoulder-back/shoulder_back_banner.png"
                alt="Bright PT clinic for shoulder care"
              />
              <div className="sb-bannerOverlay">
                <div className="sb-bannerText">
                  Shoulder sessions happen in a calm, one-on-one environment where we match your plan
                  to your work, hobbies, and goals—from daily tasks to sports.
                </div>
                <div className="sb-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule a shoulder visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="sb-stripe">
            <div className="sb-bottomStrip">
              <div className="sb-bottomText">
                If you notice sudden severe shoulder pain after a fall, can&apos;t move your arm, see
                obvious deformity, or experience chest pain, shortness of breath, or jaw/arm pain,{" "}
                <strong>seek medical or emergency care first.</strong> Physical therapy can then help guide
                safe recovery once serious causes are ruled out.
              </div>
              <div className="sb-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule shoulder PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default ShoulderBackPT;
